import { render, staticRenderFns } from "./Form.vue?vue&type=template&id=c4b380de&scoped=true&lang=html&"
import script from "./Form.vue?vue&type=script&lang=js&"
export * from "./Form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4b380de",
  null
  
)

export default component.exports